import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../_metronic/_partials/controls';
import BootstrapTable from 'react-bootstrap-table-next';
import { NoRecordsFoundMessage, PleaseWaitMessage, sortCaret, headerSortingClasses } from '../../_metronic/_helpers';
import { useSubheader } from '../../_metronic/layout';
import { Link, useHistory } from 'react-router-dom';
import { baseURLV1 } from '../service/API.js';
import moment from 'moment';
import Swal from 'sweetalert2';
import axios from 'axios';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Pagination2 from '@material-ui/lab/Pagination';
import { useSelector } from 'react-redux';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
//import {checkPermission} from '../modules/function/checkPermission.js'

export const TargetGroupNew = () => {
  const suhbeader = useSubheader();
  let allData = [];
  const [Banner, setBannerData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalSize, setTotalSize] = useState(100);
  const [openImage, setOpenImage] = useState(false);
  const [imgSelect, setImgSelect] = useState('');
  const [rotation, setRotation] = useState(0);
  const [id, setId] = useState('');
  const [relate_product_check, setRelateProductCheck] = useState(false);
  const { authToken, accessTokenPrivilege } = useSelector((state) => state.auth);
  suhbeader.setTitle('Menu');
  const history = useHistory();
  useEffect(() => {
    /*const check = checkPermission('ADMIN')
    if (!check) {
      history.push('/error')
    }*/
    localStorage.removeItem('limitPage');
    localStorage.removeItem('checkPage');
    getData(1, 10, search);
  }, []);

  const getData = async (page, limit, search) => {
    allData = [];
    setPage(page);
    axios({
      method: 'get',
      url: `${baseURLV1}/targetGroup?page=${page}&limit=${limit}${search !== undefined && search !== '' ? '&search=' + search : ''}`,
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
    }).then((res) => {
      if (res.message) {
        //history.push("/logout");
      } else {
        console.log(res.data);

        res.data.data.map((data, index) => {
          data = {
            id: data.id,
            created_at: data.created_at,
            created_by: data.created_by,
            created_by_id: data.created_by_id,
            is_active: data.is_active,
            name_en: data.name_en,
            name_th: data.name_th,
            description_en: data.description_en,
            description_th: data.description_th,
            for_you: data.for_you,
            updated_at: data.updated_at,
            updated_by: data.updated_by,
            updated_by_id: data.updated_by_id,
          };
          allData.push(data);
        });
      }
      var totalpage = Math.ceil(res.data.total / res.data.limit);
      setTotalPage(totalpage);
      setTotalSize(res.data.total);
      setLimit(res.data.limit);
      setBannerData(allData);
      console.log(allData);
    });
  };

  const handleChangeSwitch = (id) => (event) => {
    let events = {
      is_active: event.target.checked,
    };
    let apiUrls = `${baseURLV1}/targetGroup/status/${id}`;
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will change status this banner !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confrim',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.value) {
        //const token = localStorage.getItem('Token')
        const resultAll = axios({
          method: 'put',
          url: apiUrls,
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          data: events,
        })
          .then((res) => {
            Swal.fire('', 'Your banner has been change status.', 'success');
            getData(1, 10, search);
          })
          .catch((err) => {
            Swal.fire('', 'Your banner has been fail to change status.', 'error');
          });
      } else if (result.dismiss == Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', '', 'info');
      }
    });
  };

  const columns = [
    // {
    //   dataField: "id",
    //   text: "ID",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   headerSortingClasses,
    // },
    {
      text: 'Status',
      dataField: 'id',
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '150px' }}>
            <FormGroup>
              <FormControlLabel
                control={<Switch checked={row.is_active} onChange={handleChangeSwitch(id)} inputProps={{ 'aria-label': 'secondary checkbox' }} />}
                label={row.is_active ? 'Active' : 'Deactive'}
              />
            </FormGroup>
          </div>
        );
      },
    },
    {
      dataField: 'id',
      text: 'id',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '70px' }}>
            <p>{row.id}</p>
          </div>
        );
      },
    },
    {
      dataField: 'name_th',
      text: 'Target name',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '170px' }}>
            <p>{row.name_th}</p>
          </div>
        );
      },
    },
    {
      dataField: 'description_th',
      text: 'Description',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '170px' }}>
            <p>{row.description_th}</p>
          </div>
        );
      },
    },

    {
      dataField: 'created_at',
      text: 'Created At',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '120px' }}>
            <p>{row.created_at ? moment(row.created_at).format('YYYY-MM-DD HH:mm:ss') : ''}</p>
          </div>
        );
      },
    },
    {
      dataField: 'created_by',
      text: 'Created By',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '120px' }}>
            <p>{row.created_by}</p>
          </div>
        );
      },
    },
    {
      dataField: 'updated_at',
      text: 'Updated Date',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '130px' }}>
            <p>{row.updated_at ? moment(row.updated_at).format('YYYY-MM-DD HH:mm:ss') : ''}</p>
          </div>
        );
      },
    },
    {
      dataField: 'updated_by',
      text: 'Updated By',
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '120px' }}>
            <p>{row.updated_by}</p>
          </div>
        );
      },
    },

    {
      text: 'Action',
      dataField: 'id',
      formatter: (id, row, rowIndex) => {
        return (
          <div style={{ width: '150px' }}>
            <button type="button" className="btn btn-primary mr-2" onClick={() => editItem({ id, row, rowIndex })}>
              Edit
            </button>

            <button type="button" className="btn btn-primary" onClick={() => deleteItem({ row, rowIndex })}>
              Delete
            </button>
          </div>
        );
      },
    },
  ];

  const rotate = () => {
    let newRotation = Number(rotation) + 90;
    if (newRotation >= 360) {
      newRotation = -360;
    }
    setRotation(newRotation);
  };

  const editItem = (data) => {
    history.push('/TargetGroup/EditTargetGroup', data);
  };

  const deleteItem = (data) => {
    console.log(data);
    Swal.fire({
      title: 'ยืนยันการลบรายการ?',
      text: 'รายการนี้จะถูกลบออก !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'ลบ!',
      cancelButtonText: 'ไม่ลบ',
    }).then((result) => {
      if (result.value) {
        axios
          .delete(`${baseURLV1}/targetGroup/${data.row.id}`)
          .then((res) => {
            Swal.fire('Success', '', 'success');
            getData(1, limit, search);
          })
          .catch((err) => {
            Swal.fire('ทำรายการไม่สำเร็จ!', '', 'error');
          });
      } else if (result.dismiss == Swal.DismissReason.cancel) {
        Swal.fire('Cancel', '', 'error');
      }
    });
  };
  const [search, setSearch] = useState();
  const handleSearch = () => {
    setPage(1);
    getData(1, limit, search);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getData(value, limit, search);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    getData(1, event.target.value, search);
  };

  const handleClose = () => {
    setId('');
    setOpenImage(false);
    setImgSelect('');
    setRelateProductCheck(false);
  };

  return (
    <Card>
      <CardHeader title="Target Group Menu">
        <CardHeaderToolbar>
          <Link to="/TargetGroup/CreateTargetGroup">
            <button type="button" className="btn btn-primary">
              + Create
            </button>
          </Link>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div className="row form-inline mb-2">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Text Search" style={{ width: '100%' }} onChange={(e) => setSearch(e.target.value)} />
            </div>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div className="form-group">
              <button type="button" id="button" className="btn btn-primary" style={{ width: '100%' }} onClick={() => handleSearch()}>
                Search
              </button>
            </div>
          </div>
        </div>

        <BootstrapTable
          keyField="id"
          data={Banner}
          columns={columns}
          wrapperClasses="table-responsive"
          bordered={false}
          classes="table table-head-custom table-vertical-center overflow-hidden"
          bootstrap4
        >
          <PleaseWaitMessage entities={Banner} />
          <NoRecordsFoundMessage entities={Banner} />
        </BootstrapTable>
        <div className=" col-lg-12">
          <div className="row">
            <div className="col-lg-6">
              <div className="mt-3">
                {'Items per Page: '}
                <select onChange={handlePageSizeChange} value={limit}>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                {`  Result : ${totalSize} records`}
              </div>
            </div>
            <div className="col-lg-6">
              <Pagination2 className="mt-3 " count={totalPage} page={page} siblingCount={1} boundaryCount={1} variant="outlined" shape="rounded" onChange={handlePageChange} />
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
